var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBasketball = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Basketball-Ball--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Basketball Ball Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.73 6.21a0.5 0.5 0 0 0 0.13 0.69c0.27 0.19 0.55 0.38 0.82 0.59a0.48 0.48 0 0 0 0.6 0A21.33 21.33 0 0 1 20 3.61a0.25 0.25 0 0 0 0.19 -0.18 0.23 0.23 0 0 0 -0.07 -0.25A11.94 11.94 0 0 0 12 0h-0.29a0.48 0.48 0 0 0 -0.35 0.16 0.53 0.53 0 0 0 -0.13 0.36 9.24 9.24 0 0 1 -1.5 5.69Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.49 8.75a0.53 0.53 0 0 0 0.15 0.4 19.27 19.27 0 0 1 1.53 1.59 0.5 0.5 0 0 0 0.62 0.11 8.75 8.75 0 0 1 8.79 0.16 0.26 0.26 0 0 0 0.27 0 0.28 0.28 0 0 0 0.11 -0.24 11.87 11.87 0 0 0 -2.14 -5.65 0.48 0.48 0 0 0 -0.48 -0.21 20.19 20.19 0 0 0 -8.64 3.47 0.49 0.49 0 0 0 -0.21 0.37Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.83 12.25a0.49 0.49 0 0 0 0 -0.7A19.78 19.78 0 0 0 11.37 10a0.5 0.5 0 0 0 -0.68 0 24.65 24.65 0 0 0 -6.52 10.68 0.5 0.5 0 0 0 0.15 0.53A12 12 0 0 0 10.77 24a0.26 0.26 0 0 0 0.24 -0.12 0.24 0.24 0 0 0 0 -0.26 8.93 8.93 0 0 1 1.82 -11.37Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.45 13.58a0.53 0.53 0 0 0 -0.36 -0.22 0.52 0.52 0 0 0 -0.4 0.14 7.52 7.52 0 0 0 -0.81 10.26 0.51 0.51 0 0 0 0.46 0.2 12.14 12.14 0 0 0 4.12 -1.21 0.51 0.51 0 0 0 0.27 -0.52 20.46 20.46 0 0 0 -3.28 -8.65Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13 8.74a7.67 7.67 0 0 0 5.32 -1.35 0.51 0.51 0 0 0 0.21 -0.39 0.49 0.49 0 0 0 -0.27 -0.41A26.27 26.27 0 0 0 2.8 5a0.48 0.48 0 0 0 -0.57 0.18A12.26 12.26 0 0 0 0.72 8.07a0.49 0.49 0 0 0 0 0.43 0.54 0.54 0 0 0 0.41 0.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22 3.91a26.94 26.94 0 0 1 3.55 1.68 0.51 0.51 0 0 0 0.66 -0.16A7.68 7.68 0 0 0 9.76 0.87a0.55 0.55 0 0 0 -0.2 -0.39 0.49 0.49 0 0 0 -0.42 -0.08 11.92 11.92 0 0 0 -5.07 2.67 0.49 0.49 0 0 0 -0.16 0.46 0.52 0.52 0 0 0 0.31 0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.76 12.9a7.43 7.43 0 0 0 -7.88 -0.9 0.51 0.51 0 0 0 -0.27 0.32 0.5 0.5 0 0 0 0.07 0.41 21.41 21.41 0 0 1 3.42 8.56 0.26 0.26 0 0 0 0.16 0.19 0.25 0.25 0 0 0 0.25 0A12 12 0 0 0 24 13.35a0.5 0.5 0 0 0 -0.24 -0.45Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37 9.12a0.51 0.51 0 0 0 0.16 -0.4 0.51 0.51 0 0 0 -0.21 -0.37L8.75 8a0.5 0.5 0 0 0 -0.61 0 9.11 9.11 0 0 1 -7.43 2.18 0.51 0.51 0 0 0 -0.38 0.09 0.5 0.5 0 0 0 -0.2 0.34A11.2 11.2 0 0 0 0 12a11.91 11.91 0 0 0 2.54 7.37 0.26 0.26 0 0 0 0.24 0.1 0.25 0.25 0 0 0 0.22 -0.13A25.89 25.89 0 0 1 9.37 9.12Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBasketball);
export default ForwardRef;